/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 18th 2022, 7:37:07 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ImageUploadFormInput, TextFormInput } from "ui-widgets";
import { COLORSCHEME } from "theme/styles";
import { OSAPIForm } from "ui-widgets";
import { Organization } from "lib/schemas";
import { IndustryPickerInput } from "core/components/IndustryPickerInput";
import { CountryPickerInput } from "core/components/CountryPickerInput";
import { CurrencyPickerInput } from "core/components/CurrencyPickerInput";
import { useGlobalScope } from "core/providers";
import { DepartmentNestedPopUpField } from "organizations/components/DepartmentNestedPopUpField";
import { useOrganizationAPIForm } from "organizations/services/OrganizationsAPI";
import { Container } from "@mui/material";
import { StepContinueButton } from "./StepContinueButton";
import { useOnboardingContext } from "onboarding/providers/OnboardingProvider";

export const SetupOrganizationStep = ({ label }) => {
  const { updateGlobalOrganizationScope } = useGlobalScope();
  const { handleNextStep } = useOnboardingContext();
  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  const onSuccessfulPost = (organization: Organization) => {
    updateGlobalOrganizationScope({ selectedOrganization: organization }); // Updating the global scope so user can quickly continue with that organization once done setting up
    handleNextStep();
  };

  const getOrganizationToOnboard = () => {
    if (selectedOrganization.organization_status === "pending") return selectedOrganization;

    return null;
  };

  const { newDepartmentDefault, useAPIFormReturn } = useOrganizationAPIForm({
    organization: getOrganizationToOnboard(),
    setOrganization: onSuccessfulPost,
  });

  return (
    <div className="banner-content-style-A">
      <Container maxWidth="sm">
        <h1 style={{ color: COLORSCHEME.primary }}>{label}</h1>

        <p className="lead">
          Let's get going. Provide your general organization details here. Don't worry, even after setup, you can always
          edit organization details and provide even more information.
        </p>

        <OSAPIForm useAPIFormReturn={useAPIFormReturn} showSubmitButton={false}>
          <TextFormInput schema_field_key="name" label="Name" />
          <IndustryPickerInput schema_field_key="sector" />
          <TextFormInput schema_field_key="email" label="Email" />
          <CountryPickerInput schema_field_key="country" />
          <CurrencyPickerInput<Organization> schema_field_key="default_currency" />
          <ImageUploadFormInput schema_field_key="logo" label="Logo" />
          <DepartmentNestedPopUpField
            schema_field_key="department_set"
            newDepartmentDefault={newDepartmentDefault}
            label={`Departments`}
            showAddWorkers={false}
          />

          <div className="banner-cta-style-A text-center">
            {/* <p style={{ color: COLORSCHEME.primary }} className="progress-text">
              2/4 Next: Setup a Portal
            </p> */}
            <StepContinueButton isLoading={useAPIFormReturn.isSendingDataToAPI} />
          </div>
        </OSAPIForm>
      </Container>
      <div className="banner-content-style-A-footer">
        <div className="footer-logo-style-A">
          <img className="image-style-B footer-A-logo" src="/img/onestop-symbol-in-circle.svg" alt="OneStop" />
        </div>
      </div>
    </div>
  );
};
